import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import {
  getGoodsOperationalById,
  goodsOperationalActions,
  updateGoodsOperational,
} from "../../../../redux/reducer/goodsOperational/goodsOperationalReducer";
import { getGoodsCategory } from "../../../../redux/reducer/goodsCategory/goodsCategoryReducer";
import { getUnitWeight } from "../../../../redux/reducer/unitWeight/unitWeightReducer";
import NumberFormatting from "../../../helper/NumberFormatting";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminGoodsOperationalEdit() {
  // Navigate
  const id = useParams();
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const data = useSelector((state) => state.goodsOperational.data);
  const goodsCategory = useSelector((state) => state.goodsCategory.data);
  const unitWeight = useSelector((state) => state.unitWeight.data);

  // Local State
  const [formData, setFormData] = useState({
    nameOfGoods: "",
    priceOfGoods: "",
    unitId: "",
    categoryId: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      const x = data.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setFormData({
          nameOfGoods: data.docs[x].nameOfGoods ? data.docs[x].nameOfGoods : "",
          priceOfGoods: data.docs[x].priceOfGoods
            ? data.docs[x].priceOfGoods
            : "",
          unitId: data.docs[x].unitId ? data.docs[x].unitId._id : "",
          categoryId: data.docs[x].categoryId
            ? data.docs[x].categoryId._id
            : "",
          unitName: data.docs[x].unitId ? data.docs[x].unitId.unitName : "",
          categoryName: data.docs[x].categoryId
            ? data.docs[x].categoryId.categoryName
            : "",
        });
      } else {
        toast.error("Data tidak ditemukan");
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (
        goodsCategory.totalDocs !== goodsCategory.docs.length &&
        value === 1
      ) {
        const getData = {
          params: {
            limit: goodsCategory.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getGoodsCategory(getData));
      } else if (
        unitWeight.totalDocs !== unitWeight.docs.length &&
        value === 2
      ) {
        const getData = {
          params: {
            limit: unitWeight.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getUnitWeight(getData));
      }
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            unitId: formData.unitId,
            nameOfGoods: formData.nameOfGoods,
            priceOfGoods: formData.priceOfGoods,
            categoryId: formData.categoryId,
          },
          token: token,
          id: id.id,
        };
        dispatch(updateGoodsOperational(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getGoodsOperationalById(dataGetById)).then((result) => {
              dispatch(
                goodsOperationalActions.editGoodsOperational(
                  result.payload.data
                )
              );
              toast.success(res.payload.message);
              navigate("/admin/produk-operational");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT PRODUK OPERATIONAL
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PILIH KATEGORI
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              select
              size="small"
              error={false}
              name="categoryId"
              onChange={handleChange}
              value={formData.categoryId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.categoryName && formData.categoryId.length > 0 ? (
                <MenuItem value={formData.categoryId}>
                  {formData.categoryName}
                </MenuItem>
              ) : (
                ""
              )}
              {goodsCategory.docs.length > 0 ? (
                goodsCategory.docs.map(
                  (data, index) =>
                    (
                      <MenuItem value={data._id} key={index}>
                        {data.categoryName}
                      </MenuItem>
                    )
                )
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              NAMA PRODUK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              size="small"
              name="nameOfGoods"
              onChange={handleChange}
              value={formData.nameOfGoods}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              HARGA PRODUK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                style: { background: "white", paddingLeft: "5px" },
              }}
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: (
                  <InputAdornment position="start">Rp. </InputAdornment>
                ),
              }}
              required
              size="small"
              name="priceOfGoods"
              onChange={handleChange}
              value={formData.priceOfGoods}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PILIH SATUAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              select
              size="small"
              error={false}
              name="unitId"
              onChange={handleChange}
              value={formData.unitId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(2),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.unitName && formData.unitId.length > 0 ? (
                <MenuItem value={formData.unitId}>{formData.unitName}</MenuItem>
              ) : (
                ""
              )}
              {unitWeight.docs.length > 0 ? (
                unitWeight.docs.map(
                  (data, index) =>
                    formData.unitId !== data._id && (
                      <MenuItem value={data._id} key={index}>
                        {data.unitName}
                      </MenuItem>
                    )
                )
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/produk-operational")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
